export class RendererSystem {
    constructor(renderer, name) {
        this.renderer = renderer;
        this.name = name;
    }
}
